import { forEach } from 'lodash-es';
import type { ComponentType, ReactElement } from 'react';
import { Component, createContext } from 'react';

import type { AuthUser } from '../auth/types';

export interface Analytics {
    initialize(user?: AuthUser): void;
    identifyUser(user: AuthUser): void | Promise<void>;
    anonymousUser(pendoObj: string): void;
    clearSession(): void;

    track(...e: unknown[]): void;
}

export class CIAnalytics {
    private static __instance: CIAnalytics = new CIAnalytics();

    public static getInstance(): CIAnalytics {
        return CIAnalytics.__instance;
    }

    private providers: Analytics[] = [];

    public initialize(user?: AuthUser): void {
        forEach(this.providers, (provider): void => provider.initialize(user));
    }

    public registerProvider(provider: Analytics): void {
        this.providers.push(provider);
    }

    public identifyUser(user: AuthUser): void {
        // identifyUser may be async (Pendo); the promise is intentionally not awaited.
        forEach(this.providers, (provider): void => provider.identifyUser(user) as void);
    }
    public anonymousUser(pendoObj: string): void {
        forEach(this.providers, (provider): void => provider.anonymousUser(pendoObj));
    }

    public clearSession(): void {
        forEach(this.providers, (provider): void => provider.clearSession());
    }
}

export const AnalyticsContext = createContext(CIAnalytics);

export default function withAnalytics(WrappedComponent: ComponentType): ComponentType {
    return class extends Component {
        public render(): ReactElement {
            return (
                <AnalyticsContext.Provider value={CIAnalytics}>
                    <WrappedComponent></WrappedComponent>
                </AnalyticsContext.Provider>
            );
        }
    };
}
